import { useState, useEffect } from 'react'

export interface PurchaseData {
  name: string
  country: string
  timeAgo: string
}

const LATAM_COUNTRIES = [
  'México',
  'Colombia',
  'Argentina',
  'Chile',
  'Perú',
  'Ecuador',
  'España',
  'Estados Unidos',
]
const FEMALE_NAMES = [
  'María',
  'Ana',
  'Laura',
  'Carmen',
  'Sofía',
  'Valentina',
  'Isabella',
  'Camila',
  'Valeria',
  'Mariana',
  'Gabriela',
  'Daniela',
  'Andrea',
  'Natalia',
  'Paula',
]
const TIMES = [
  'hace 2 minutos',
  'hace 5 minutos',
  'hace 12 minutos',
  'hace 1 hora',
  'hace 3 horas',
  'hace 15 minutos',
  'hace 45 minutos',
]

export function usePurchasePopup() {
  const [currentPurchase, setCurrentPurchase] = useState<PurchaseData | null>(
    null,
  )
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    // Initial delay before first popup
    const initialTimeout = setTimeout(() => {
      showRandomPurchase()
    }, 15000) // 15 seconds

    return () => clearTimeout(initialTimeout)
  }, [])

  const showRandomPurchase = () => {
    const name = FEMALE_NAMES[Math.floor(Math.random() * FEMALE_NAMES.length)]
    const country =
      LATAM_COUNTRIES[Math.floor(Math.random() * LATAM_COUNTRIES.length)]
    const timeAgo = TIMES[Math.floor(Math.random() * TIMES.length)]

    setCurrentPurchase({ name, country, timeAgo })
    setIsVisible(true)

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false)

      // Schedule next popup (between 20 and 45 seconds)
      const nextDelay = 20000 + Math.random() * 25000
      setTimeout(showRandomPurchase, nextDelay)
    }, 5000)
  }

  return { currentPurchase, isVisible }
}
